import * as React from "react";
// UI Frameworks
import { Button as AntdButton } from "antd";
import { ButtonProps } from "antd/lib/button";
// Utilities and hooks
import cs from "classnames";
// Styles
import styles from "./index.module.scss";

interface IProps extends ButtonProps {
	primary?: boolean;
	children?: React.ReactNode;
	info?: boolean;
	green?: boolean;
}
const Button: React.FC<IProps> = ({ className, primary, children, info, green, ...restProps }) => {
	return (
		<AntdButton
			{...restProps}
			className={cs(styles.button, className, {
				[styles["button--primary"]]: primary,
				[styles["button--green"]]: green,
				[styles["button--info"]]: info,
			})}
		>
			{children}
		</AntdButton>
	);
};

export default Button;
